/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type AgentFilterPropertyTypesItem =
  (typeof AgentFilterPropertyTypesItem)[keyof typeof AgentFilterPropertyTypesItem];

export const AgentFilterPropertyTypesItem = {
  APARTMENT_BUILDING: "APARTMENT_BUILDING",
  TOWN_HOUSES: "TOWN_HOUSES",
  DETACHED_HOUSES: "DETACHED_HOUSES",
  DETAIL: "DETAIL",
  COMMERCIAL: "COMMERCIAL",
  INSTITUTIONS: "INSTITUTIONS",
  UNKNOWN: "UNKNOWN",
} as const;
